/**
 * Which code path resolves an inbound redirect source's requests.
 * Values match the backend InboundRedirectHandlerTypeEnum.
 */
export enum InboundRedirectHandlerTypeEnum {
    Legacy = 0,
    Plugin = 1
}

export const InboundRedirectHandlerTypeLabels: Record<InboundRedirectHandlerTypeEnum, string> = {
    [InboundRedirectHandlerTypeEnum.Legacy]: 'Built-in',
    [InboundRedirectHandlerTypeEnum.Plugin]: 'Teller plugin'
};

export class InboundRedirectHandlerTypeEnumHelpers {
    static getOptions(): { value: number; label: string }[] {
        return Object.keys(InboundRedirectHandlerTypeEnum)
            .filter(key => !Number.isNaN(Number(key)))
            .map(key => ({
                value: Number(key),
                label: InboundRedirectHandlerTypeLabels[
                    Number(key) as InboundRedirectHandlerTypeEnum
                ]
            }));
    }
}
